import { ApplicationMenuRoute } from 'common/types/urlRoutes/applicationMenuRoute';
import {
  breakpointAnalysisUrl, captableUrl, companySummaryUrl, documentGenerationJobsUrl, documentsUrl, financialUrl,
  valuationUrl, waterfallUrl
} from '../../common/config/urls';
import { WATERFALL_SLUG, WATERFALL_TITLE } from '../../common/constants/allocations';
import {
  CAP_TABLE_SLUG, CAP_TABLE_TITLE
} from '../../common/constants/cap-table';
import { COMPANIES_SUMMARY_SLUG, COMPANIES_SUMMARY_TITLE } from '../../common/constants/companies';
import { DOCUMENT_GENERATION_JOBS_SLUG, DOCUMENT_GENERATION_JOBS_TITLE, DOCUMENTS_SLUG, DOCUMENTS_TITLE } from '../../common/constants/documents';
import { DOCUMENT_GENERATION_JOBS } from '../../common/constants/features';
import { FINANCIAL_SLUG, FINANCIAL_TITLE } from '../../common/constants/financials';
import { VALUATIONS_SLUG, VALUATIONS_TITLE } from '../../common/constants/valuations';

export const COMPANY_ROUTES: ApplicationMenuRoute[] = [
  {
    id: 'summary',
    route: companySummaryUrl,
    hidden: false,
    title: COMPANIES_SUMMARY_TITLE,
    slug: COMPANIES_SUMMARY_SLUG,
  },
  {
    id: 'financial',
    route: financialUrl,
    hidden: false,
    title: FINANCIAL_TITLE,
    slug: FINANCIAL_SLUG,
  },
  {
    id: 'captable',
    route: captableUrl,
    hidden: false,
    title: CAP_TABLE_TITLE,
    slug: CAP_TABLE_SLUG,
  },
  {
    route: valuationUrl,
    id: 'valuation',
    hidden: false,
    slug: VALUATIONS_SLUG,
    title: VALUATIONS_TITLE,
  },
  {
    route: waterfallUrl,
    id: 'waterfall',
    hidden: false,
    slug: WATERFALL_SLUG,
    title: WATERFALL_TITLE,
  },
  {
    id: 'documents',
    route: documentsUrl,
    hidden: false,
    slug: DOCUMENTS_SLUG,
    title: DOCUMENTS_TITLE,
  },
  {
    route: documentGenerationJobsUrl,
    hidden: false,
    featureFlag: DOCUMENT_GENERATION_JOBS,
    id: 'document-generation-jobs',
    slug: DOCUMENT_GENERATION_JOBS_SLUG,
    title: DOCUMENT_GENERATION_JOBS_TITLE,
  },
].map((route, index) => ({
  ...route,
  itemKey: route.itemKey ?? index,
}));